import {API_BASE_URL} from "./settings.js";

export const API_URL = {
  LOGIN: API_BASE_URL +  'user/login',
  REFRESH: 'user/refreshToken',
  DRIVE_USER: '/drive-service/user',
  DRIVE_FILE: '/drive-service/file',
  DRIVE_FOLDER: '/drive-service/folder',
  USER_GET: 'user/get',
  CAD_SERVICE: '/cad-service/tasks/drive'
};
